import React from "react";
import { Select } from "antd";

const SearchByName = (props) => {
  // -------------------------- VAR --------------------------
  const { search, setSearch } = props;
  const { options } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (option) => {
    setSearch(option);
  };
  const handleClear = () => {
    setSearch("");
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Select
      style={{ width: "100%" }}
      placeholder="Search By Name.."
      allowClear
      showSearch
      options={options}
      onSelect={(option) => handleChange(option)}
      onClear={handleClear}
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    />
  );
};

export default SearchByName;
